import React from 'react';

function OrderProduct({ product }) {
  return (
    <div className="flex justify-between items-center p-4 ">
      <div className="flex items-center gap-4">
        <img
          src={product?.image}
          alt={product?.name}
          className="w-14 h-14 rounded-md object-cover"
        />
        <div className="flex flex-col justify-center text-left">
          <span className="font-medium text-gray-800 text-sm">{product?.name}</span>
          <span className="text-gray-500 text-xs">{product?.sku}</span>
        </div>
      </div>

      <div className="flex flex-col items-end gap-2">
        <span className="font-semibold text-gray-800">{product?.price}</span>
        <div className="flex items-center text-xs text-gray-600">
          <span className="mr-1">QTY:</span>
          <span>{product?.quantity}</span>
        </div>
      </div>
    </div>
  );
}

export default OrderProduct;
